import React, {useState} from 'react'
import styled from 'styled-components'
import Logo from '../../assets/svg/logo.inline.svg'
import Navigation from './Navigation'
import {Link} from 'gatsby'
import MenuIcon from '../atoms/MenuIcon'
import SmallNavigation from '../organisms/SmallNavigation'
import Container from '../atoms/Container'
import HeaderScrollTransition from '../atoms/HeaderScrollTransition'
import classNames from 'classnames'
import PropTypes from 'prop-types'

const Holder = styled.div`
`

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  justify-content: space-between;
  padding: 2rem 0 1rem 0;
  @media ( ${props => props.theme.breakpoints.md} ) {
    padding: 1.5rem 0 1rem 0;
    grid-template-columns: 1fr 3fr;
  }
  @media ( ${props => props.theme.breakpoints.lg} ) {
    padding: 1.5rem 0 1rem 0;
    grid-template-columns: 1fr 4fr;
  }

  .logo-holder {
    svg {
      height: 1.4rem;
      width: auto;
      display: block;
      margin-top: 0.2rem;
      @media ( ${props => props.theme.breakpoints.md} ) {
        margin: 0;
        height: 1.8rem;
      }

      path, rect {
        fill: ${props => props.navOpen ? props.theme.colours.black4 : props.theme.colours.white};
      }
    }
  }

  &.dark {
    .logo-holder svg {
      path, rect {
        fill: ${props => props.theme.colours.black1};
      }
    }

    .menu-icon svg path {
      stroke: ${props => props.theme.colours.black1};
    }

    .navigation ul {
      color: ${props => props.theme.colours.black1};
    }
  }

`

const ButtonHolder = styled.div`
  text-align: right;
  @media ( ${props => props.theme.breakpoints.md} ) {
    display: none;
  }
`
const LargeNavHolder = styled.div`
  display: none;
  @media ( ${props => props.theme.breakpoints.md} ) {
    display: block;
  }
`
const Banner = styled.div`
  padding: 0 1rem;
  color: ${props => props.theme.colours.white};
  background-color: ${props => props.theme.colours.green};
  position: relative;
  z-index: 10;
  font-weight: bold;
  height: 4rem;
  overflow: hidden;
  transition: height 0.2s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
  @media ( ${props => props.theme.breakpoints.md} ) {
    padding: 0 2rem;
    height: 3rem;
  }

  p {
    ${props => props.theme.fluidType(-3)};
    margin: 0;
    text-align: center;
    @media ( ${props => props.theme.breakpoints.sm} ) {
      ${props => props.theme.fluidType(-2)};
    }
    @media ( ${props => props.theme.breakpoints.lg} ) {
      ${props => props.theme.fluidType(-1)};
    }
  }

  &.inverse {
    color: ${props => props.theme.colours.black4};
    background-color: ${props => props.theme.colours.cream};
  }

  &.collapse {
    height: 0;
  }
`

function Header({dark, showAnnouncement, inverseAnnouncement, caseStudies, hide}) {
    const [navOpen, setNavOpen] = useState(false)
    let gridClasses = classNames({
        'header-grid': true,
        'nav-open': navOpen,
        'dark': dark
    })
    let bannerClasses = classNames({
        'inverse': inverseAnnouncement,
        'collapse': navOpen,
    })

    if (hide) return null

    return (
        <Holder>
            <HeaderScrollTransition caseStudies={caseStudies}>
                {showAnnouncement && <Banner className={bannerClasses}>
                    <p>The EPA Clean School Bus Program is the largest school bus funding opportunity in U.S.
                        history. <Link to="/epa">Learn More</Link></p>
                </Banner>}
                <Container>
                    <Grid caseStudies={caseStudies} className={gridClasses} navOpen={navOpen}>
                        <div className="logo-holder">
                            <Link to="/">
                                <Logo/>
                            </Link>
                        </div>
                        <ButtonHolder>
                            <button className="icon" onClick={() => setNavOpen(!navOpen)} aria-label="Open navigation">
                                <MenuIcon navOpen={navOpen}/>
                            </button>
                        </ButtonHolder>
                        <LargeNavHolder>
                            <Navigation/>
                        </LargeNavHolder>
                    </Grid>
                </Container>
            </HeaderScrollTransition>
            <SmallNavigation show={navOpen} clickHandler={() => setNavOpen(false)}/>
        </Holder>
    )
}

Header.propTypes = {
    dark: PropTypes.bool,
    showAnnouncement: PropTypes.bool,
    inverseAnnouncement: PropTypes.bool,
}

export default Header
